export const selectRTDB = (state: any): any => state.rtdb;
